export default "__VITE_ASSET__DBI_NUYn__"